module.exports = __webpack_public_path__ + "img/logo-im.c75e2671.svg";